import React, { useContext, useEffect } from 'react';
import EDDialog from '../../../BaseComponents/Dialog/EDDialog';
import { IRapportInfo } from '../../../Types/RapportInfoType';
import { LoginStateContext } from '../../Login/Contexts/LoginStateContext/LoginStateContext';
import { RutinSettingsContext } from '../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { rutiner } from '../_Common/Const/Rutiner';
import OnStartWarningDialog from '../_Common/Components/OnStartWarningDialog/OnStartWarningDialog';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import { rapportRouteName } from '../../Routing/router';

interface IProps {
  rapport: IRapportInfo;
  onExport: () => void;
  onClose?: () => void;
  exportDisabled?: boolean;
  exportDisabledReason?: string;
}

const StandardRapport: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { setActiveRoutine } = useContext(RutinSettingsContext);
  const loginStateContext = useContext(LoginStateContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setActiveRoutine(props.rapport.rutinID);
    return setActiveRoutine;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const routine = rutiner[props.rapport.rutinID];

  let loading = false;
  let ok = true;
  let warningText = '';
  if (routine && routine.onStartWarningHook != null) {
    ({ loading, ok, warningText } = routine.onStartWarningHook(
      loginStateContext.isLoggedIn
    ));
  }

  const closeDialog = () => {
    navigate(
      location.pathname.replace(
        new RegExp(rapportRouteName + '.*$'),
        rapportRouteName
      ),
      { replace: true }
    );
  };

  return !loading && ok ? (
    <EDDialog
      open
      disableResponsiveFullScreen
      fullScreenBreakpoint={'sm'}
      title={props.rapport.benamning}
      subtitle={props.rapport.typ}
      footerActions={[
        {
          label: 'Stäng',
          onClick: props.onClose ?? closeDialog,
        },
        {
          label: 'Exportera',
          onClick: props.onExport,
          buttonProps: {
            disabled: props.exportDisabled,
            disabledReason: props.exportDisabledReason,
          },
        },
      ]}
      onClose={props.onClose ?? closeDialog}
    >
      {props.rapport.beskrivning && (
        <EDTypography variant="body2" paragraph>
          {props.rapport.beskrivning}
        </EDTypography>
      )}
      {props.children}
    </EDDialog>
  ) : (
    <OnStartWarningDialog
      loading={loading}
      ok={ok}
      warningText={warningText}
      isLoggedIn={loginStateContext.isLoggedIn}
    />
  );
};
export default StandardRapport;
